import { ServiceRequestConfig } from '~/services/createService';
import { pilot } from '~/services/serviceInstances';

type ToggleMuteAlertRequest = {
  id: number;
  mute: boolean;
};

export const toggleMuteAlert = async (
  { id, mute }: ToggleMuteAlertRequest,
  options: ServiceRequestConfig = {},
) => {
  return await pilot.patch(`/alert/${id}/mute/`, { mute }, options);
};
